import React, { useContext, useEffect } from 'react'
import { Edit } from '@mui/icons-material'
import store from 'state/store'
import { showFormModal } from 'state/ui'
import { Stack, Typography } from '@mui/material'
import { Chip } from 'components/generic/chip'
import ContentLayoutContext from 'components/layouts/ContentLayoutContextProvider'
import FORM_MODALS from 'utils/ui/modals'

export const useMaterialHeader = materialTypeData => {
  const context = useContext(ContentLayoutContext)
  const pageActions = [
    {
      icon: <Edit />,
      text: 'Edit Properties',
      id: 'edit-material-type',
      onClick: () => {
        store.dispatch(
          showFormModal({
            formModalName: FORM_MODALS.NEW_MATERIAL,
            formModalProps: { materialTypeId: materialTypeData?.id },
          }),
        )
      },
    },
  ]

  useEffect(() => {
    context.setContainerActions(materialTypeData?.archive ? [] : pageActions)
    context.setContainerTitle(
      materialTypeData?.archive ? (
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <Typography variant="h5">{materialTypeData?.commonName}</Typography>
          <Chip label="Archived" sx={{ marginLeft: '16px' }} />
        </Stack>
      ) : (
        materialTypeData?.commonName || '---'
      ),
    )
  }, [materialTypeData])
}
